import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import Button from '../CustomButton/Button'
import './recovery.css'
import { Container } from "react-bootstrap";
import host from "../../host";
import { showNotification } from '../../utils/notificationUtils';


function Login() {
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [tabNum, setTabNum] = useState('');
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [step, setStep] = useState(1);
    const navigate = useNavigate()
    const dispatch = useDispatch();


    const handleSubmit = () => {
        if (tabNum.length === 5) {
            axios.post(`${host}api/examination/`, { username: tabNum }, { withCredentials: true })
                .then((response) => {
                    if (response.status === 200) {
                        setStep(2);
                        showNotification(dispatch, 'На ваш номер отправлено смс с кодом', 'success');
                    }
                    else {
                        showNotification(dispatch, 'Неверный табельный номер', 'error');
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        showNotification(dispatch, 'Неверный табельный номер', 'error');
                    } else if (error.request) {
                    } else {
                    }
                });
        }
        else {
            showNotification(dispatch, 'Табельный должен содержать 5 цифр', 'error');
        }

    };

    const checkCode = () => {
        axios.post(`${host}api/check-code/`, { code: code }, { withCredentials: true })
            .then((response) => {
                if (response.status === 200) {
                    setStep(3);
                    showNotification(dispatch, 'Код верный', 'success');
                }
                else {
                    showNotification(dispatch, 'Неверный код из смс', 'error');
                }
            })
            .catch((error) => {
                if (error.response) {
                    showNotification(dispatch, error.response.data['message'], 'error');
                } else if (error.request) {
                    showNotification(dispatch, 'Ошибка сервера', 'error');
                } else {
                    showNotification(dispatch, 'Ошибка сервера', 'error');
                }
            });
    };

    const chnagePass = () => {
        if (password === password2) {
            axios.post(`${host}api/change_password/`, { new_password: password }, { withCredentials: true })
                .then((response) => {
                    if (response.status === 200) {
                        navigate('note/login');
                        showNotification(dispatch, 'Теперь можете войти', 'success');
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        setError(error.response.data['error']);
                    } else if (error.request) {
                        showNotification(dispatch, 'Ошибка сервера', 'error');
                    } else {
                        showNotification(dispatch, 'Ошибка сервера', 'error');
                    }
                });
        }
        else {
            showNotification(dispatch, 'Пароли не совпадают', 'error');
        };
    }



    return (
        <Container fluid className="cont-lg d-flex justify-content-center align-items-center">
            {error && <div className="alert alert-danger" role="alert">{error}</div>}
            {step === 1 && (
                <Form className="form-container shadow-lg p-4 rounded" onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                }}>
                    <Form.Group className="mb-3" controlId="formBasicTab">
                        <Form.Label >Табельный номер</Form.Label>
                        <Form.Control type="phone" placeholder="Введите ваш табельный номер" value={tabNum}
                            onChange={e => setTabNum(e.target.value)} />

                        <Button type="submit" className="btn-outline" style={{ marginTop: 10, width: '100%' }}  >
                            Отправить
                        </Button>
                    </Form.Group>
                </Form>
            )}

            {step === 2 && (
                <Form className="form-container shadow-lg p-4 rounded" onSubmit={(e) => {
                    e.preventDefault();
                    checkCode();
                }}>
                    <Form.Group className="mb-3" controlId="formBasicCode">
                        <Form.Label >Код из смс</Form.Label>
                        <Form.Control type="code" placeholder="Введите код из смс" value={code}
                            onChange={e => setCode(e.target.value)} />
                        <Button type="submit" className="btn-outline" style={{ marginTop: 10, width: '100%' }} >
                            Проверить
                        </Button>
                    </Form.Group>
                </Form>
            )}

            {step === 3 && (
                <Form className="form-container shadow-lg p-4 rounded" onSubmit={(e) => {
                    e.preventDefault();
                    chnagePass();
                }}>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Пароль</Form.Label>
                        <Form.Control type="password" placeholder="Введите новый пароль" value={password}
                            onChange={e => setPassword(e.target.value)} />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicPassword1">
                        <Form.Label>Пароль еще раз</Form.Label>
                        <Form.Control type="password" placeholder="Введите новый пароль еще раз" value={password2}
                            onChange={e => setPassword2(e.target.value)} />
                    </Form.Group>
                    <Button type="submit" className="btn-outline" style={{ marginTop: 10, width: '100%' }} >
                        Сменить
                    </Button>
                </Form>
            )}
        </Container>
    );
}

export default Login;